import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { FaUserPlus, FaTrash, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const ROLE_COLORS = [
  '#395A96', // blue
  '#4287f5', // light blue
  '#F59E42', // orange
  '#42F5B3', // teal
  '#F542A7', // pink
  '#A742F5', // purple
  '#F54242', // red
  '#42F554', // green
  '#FFD700', // gold
  '#7B8A8B', // gray
];

const generatePin = () => Math.floor(1000 + Math.random() * 9000).toString();

const TeamMembers = ({
  teamMembers,
  roles,
  country,
  errors = {},
  onChange,
  openIndex,
  setOpenIndex,
  onAdd,
  onDelete,
  onRegeneratePin,
  adminName,
  adminPhone
}) => {
  return (
    <div className="space-y-4">
      {teamMembers.map((member, index) => (
        <div key={index} className="mb-2 border rounded-xl shadow-sm bg-white">
          <div
            className="flex items-center justify-between px-4 py-3 cursor-pointer select-none"
            onClick={() => setOpenIndex(index)}
          >
            <div className="flex items-center">
              <div className="w-10 h-10 rounded-full flex items-center justify-center mr-3" style={{ background: '#eee' }}>
                <FaUserPlus className="text-white text-xl" />
              </div>
              <span className="font-medium text-gray-700">
                {index === 0 ? 'Admin' : [member.name, member.lastName].filter(Boolean).join(' ') || 'New'}
              </span>
            </div>
            {index > 0 && (
              <div className="flex items-center gap-2">
                <button 
                  onClick={e => { 
                    e.stopPropagation(); 
                    onDelete(index);
                  }} 
                  className="text-red-500 hover:text-red-700"
                >
                  <FaTrash />
                </button>
                {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            )}
          </div>
          {openIndex === index && (
            <div className="p-4 pt-0 space-y-4">
              {index === 0 ? (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Admin Name</label>
                    <input
                      type="text"
                      value={adminName || ''}
                      readOnly
                      disabled
                      className="w-full px-3 py-2 rounded-xl bg-gray-100 border-2 border-gray-200 text-black cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">PIN</label>
                    <div className="flex gap-2">
                      <input
                        type="text"
                        value={member.pin}
                        onChange={e => {
                          const updated = [...teamMembers];
                          updated[0].pin = e.target.value;
                          onChange(updated);
                        }}
                        maxLength={4}
                        inputMode="numeric"
                        className="w-full px-3 py-2 rounded-xl bg-white/80 border-2 border-gray-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-black transition-all duration-300 shadow-sm hover:shadow-md"
                      />
                      <button
                        onClick={() => onRegeneratePin(0)}
                        className="px-4 py-2 bg-primary text-white rounded-xl hover:bg-secondary transition-colors"
                      >
                        Regenerate
                      </button>
                    </div>
                    {errors[0]?.pin && <div className="text-red-600 text-xs mt-1">{errors[0].pin}</div>}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
                    <input
                      type="text"
                      value={adminPhone || ''}
                      readOnly
                      disabled
                      className="w-full px-3 py-2 rounded-xl bg-gray-100 border-2 border-gray-200 text-black cursor-not-allowed"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                    <input
                      type="text"
                      value={member.name}
                      onChange={e => {
                        const updated = [...teamMembers];
                        updated[index].name = e.target.value;
                        onChange(updated);
                      }}
                      className="w-full px-3 py-2 rounded-xl bg-white/80 border-2 border-gray-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-black transition-all duration-300 shadow-sm hover:shadow-md"
                    />
                    {errors[index]?.name && <div className="text-red-600 text-xs mt-1">{errors[index].name}</div>}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                    <input
                      type="text"
                      value={member.lastName}
                      onChange={e => {
                        const updated = [...teamMembers];
                        updated[index].lastName = e.target.value;
                        onChange(updated);
                      }}
                      className="w-full px-3 py-2 rounded-xl bg-white/80 border-2 border-gray-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-black transition-all duration-300 shadow-sm hover:shadow-md"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">PIN</label>
                    <div className="flex gap-2">
                      <input
                        type="text"
                        value={member.pin}
                        onChange={e => {
                          const updated = [...teamMembers];
                          updated[index].pin = e.target.value;
                          onChange(updated);
                        }}
                        maxLength={4}
                        inputMode="numeric"
                        className="w-full px-3 py-2 rounded-xl bg-white/80 border-2 border-gray-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-black transition-all duration-300 shadow-sm hover:shadow-md"
                      />
                      <button
                        onClick={() => onRegeneratePin(index)}
                        className="px-4 py-2 bg-primary text-white rounded-xl hover:bg-secondary transition-colors"
                      >
                        Regenerate
                      </button>
                    </div>
                    {errors[index]?.pin && <div className="text-red-600 text-xs mt-1">{errors[index].pin}</div>}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Level</label>
                    <select
                      value={member.level}
                      onChange={e => {
                        const updated = [...teamMembers];
                        updated[index].level = e.target.value;
                        onChange(updated);
                      }}
                      className="w-full px-4 py-2 rounded-lg bg-white/80 border border-gray-300 focus:border-secondary focus:ring-1 focus:ring-secondary text-black transition text-sm"
                    >
                      <option value="">Select level</option>
                      {roles.map((role, i) => (
                        <option key={i} value={role.name}>{role.name}</option>
                      ))}
                    </select>
                    {errors[index]?.level && <div className="text-red-600 text-xs mt-1">{errors[index].level}</div>}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Phone (Optional)</label>
                    <PhoneInput
                      country={(country || '').toLowerCase()}
                      value={member.phone}
                      onChange={value => {
                        const updated = [...teamMembers];
                        updated[index].phone = value;
                        onChange(updated);
                      }}
                      inputClass="w-full px-3 py-2 rounded-xl bg-white/80 border-2 border-gray-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-black transition-all duration-300 shadow-sm hover:shadow-md"
                      buttonClass="border-2 border-gray-200 rounded-l-xl"
                      dropdownClass="border-2 border-gray-200 rounded-xl shadow-lg"
                      searchClass="border-2 border-gray-200 rounded-xl"
                      containerClass="phone-input-container"
                      enableSearch={true}
                      searchPlaceholder="Search country..."
                      searchNotFound="No country found"
                      preferredCountries={['us', 'gb', 'ca', 'au', 'in']}
                    />
                    {errors[index]?.phone && <div className="text-red-600 text-xs mt-1">{errors[index].phone}</div>}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      ))}
      <button
        type="button"
        onClick={onAdd}
        className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors"
      >
        + Add Team Member
      </button>
    </div>
  );
};

export default TeamMembers; 